import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {  getPermission } from '../../controller/user.js';
import { app } from '../../config/app.js';
import {  Link, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { updateDocToDb, getDataCount } from '../../controller/firestore.js';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import GavelIcon from '@mui/icons-material/Gavel';
import ListItemText from '@mui/material/ListItemText';
import { Divider } from '@mui/material';

export default function CercaCandidato(props) {
  const user=props.user;
  const collectionName="guide";
  const location=useLocation();
  const httpdata = location.state && location.state.data;
    
  const candidatoData=(httpdata && httpdata.selectedData?httpdata.selectedData:null);
  //console.log("Candidato data",candidatoData);
  const id=(httpdata && httpdata.id?httpdata.id:null);
 // const callerUrl=httpdata.callerUrl;
  const activePermission=getPermission("collection",collectionName,null,user);
  
  const collectionConfig=app.collections_config[collectionName];
  const [docGuida,setDocGuida] =useState({});
  const [errorMessage,setErrorMessage] =useState("");
  const [innerChanged,setInnerChanged]=useState(null);
  const findCandidatoLink="/candidati/";
  const nuovaGuidaLink="/guide/crea";
  const schedaLink="/guide/scheda";
  
  const elencoLink="/guide/elenco";
  
  const esamiLink="/candidato/esami";
  //const [candidato,setCandidato]=useState(null);
  const currentPath = location.pathname;
  let pagamentiArr=[];
  const [lezioniPagate,setLezioniPagate]=useState(0);
  useEffect(() => {
//      console.log("Candidato data aggiornato use effect");
//  console.log(candidatoData);
        if (candidatoData) {
        let doc=candidatoData.docData;
        
        let lezioniPagate=0;
        if (doc.pagamenti) {
            doc.pagamenti.forEach(pag => {
                lezioniPagate+=pag.lezioniPagate;
            });
        }
        setLezioniPagate(lezioniPagate);
        //console.log("Lezioni pagate",lezioniPagate);
      }
  }, [candidatoData]);
  const [guideEffettuate,setGuideEffettuate]=useState(0);
          const [reloadGuideCount,setReloadGuideCount]=useState(true);
          useEffect(() => {
            const fetchGuideCount = async () => {
              const activePermission=getPermission("collection","guide",null,user);
              const params={
                "permission":activePermission,        
                "user":user,
                "filters":{
                      "candidato":{type:'equalTo', value:candidatoData.id}
                  
                }
              };
              try {
                const data = await getDataCount("guide", app.collections_config["guide"]["views"]["tableCandidato"], params);
                setGuideEffettuate(data.rowsLength);
              //  console.log("Guide count", data);
          
               // console.log("Istruttori", istruttoriMap);
               setReloadGuideCount(false);
              } catch (error) {
             //   setErrorMessageHeader("Errore");
              //  setErrorMessage("Error fetching istruttori: " + error.message);
              }
            };
            if (reloadGuideCount && candidatoData)
              fetchGuideCount();
          }, []);
  return (
    <div>
      {candidatoData === null ? (
        <Typography sx={{ mb: 2 }} variant="h5">
        <Navigate to={ findCandidatoLink } state={{ data: { viewAction: 'singleChoice', viewConfig:'tableSimple', callbackViewActionUrl:currentPath} }} style={{ textDecoration: 'underline', color: '#1976d2' }}>
          Seleziona un candidato
        </Navigate>
        </Typography>
      ) : (
        <div>
          <Typography sx={{ mb: 2 }} variant="h6">
            <b>{candidatoData.nome} {candidatoData.cognome}</b> (Cat. {app.category[candidatoData.categoria]}) - <Link to={ findCandidatoLink } state={{ data: { viewAction: 'singleChoice', callbackViewActionUrl:currentPath} }} style={{ textDecoration: 'underline', color: '#1976d2' }}>
          Cambia candidato
          </Link> </Typography>
          
          <ListItemButton 
          onClick={(event) => {
            if (lezioniPagate<=guideEffettuate) {
            // Esegui il tuo script JavaScript
            const proceed = window.confirm("La guida che vuoi registrare risulta non essere stata saldata. Procedere ugualmente?");
            
            // Se l'utente sceglie "No", blocca la navigazione
            if (!proceed) {
              event.preventDefault();
            }
          }
          }}
          component={Link} to={ nuovaGuidaLink } state={{ data: { candidato: candidatoData} }}>
           
            <ListItemIcon>
              <DriveEtaIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'h6' }} primary="Nuova guida" secondary="Registra una nuova sessione di guida" />
          </ListItemButton>
          <ListItemButton component={Link} to={ schedaLink } state={{ data: { candidato: candidatoData} }}>
            <ListItemIcon>
              <AssessmentIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'h6' }} primary="Scheda" secondary="Consulta la scheda del candidato" />
          </ListItemButton>
          <ListItemButton component={Link} to={ elencoLink } state={{ data: { candidato: candidatoData} }}>
            <ListItemIcon>
              <FormatListBulletedIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'h6' }} primary="Elenco Guide" secondary="Visualizza/modifica guide del candidato" />
          </ListItemButton>

          <ListItemButton component={Link} to={ esamiLink } state={{ data: { candidato: candidatoData} }}>
            <ListItemIcon>
              <GavelIcon />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{ variant: 'h6' }} primary="Esami" secondary="Visualizza/modifica esami del candidato" />
          </ListItemButton>
 
          <Divider sx={{pt:0}}  textAlign="left"></Divider>
          <Typography sx={{pt:2}} gutterBottom>Numero guide registrate: {guideEffettuate}</Typography>

<Typography sx={{pt:0, color: lezioniPagate < guideEffettuate ? 'red' : 'inherit' }}  gutterBottom>Numero guide Saldate: {lezioniPagate}</Typography>      
        </div>
      )}
    </div>
  );
}